import PropTypes from "prop-types";

import archidekt from "assets/ads/archidekt.png";
import cc from "assets/ads/cc.png";
import ch from "assets/ads/ch.png";
import csb from "assets/ads/csb.png";
import fabrec from "assets/ads/fabrec.png";
import OutboundLink from "components/OutboundLink";

import styles from "./Ad.module.scss";

const config = {
  archidekt: { alt: "Archidekt", src: archidekt, url: "archidekt.com" },
  cc: { alt: "Commander Codex", src: cc, url: "commandercodex.com" },
  ch: { alt: "Commander's Herald", src: ch, url: "commandersherald.com" },
  csb: { alt: "Commander Spellbook", src: csb, url: "commanderspellbook.com" },
  fabrec: { alt: "FABREC", src: fabrec, url: "fabrec.gg" },
};

const Ad = ({ id }) => {
  if (!Object.keys(config).includes(id)) {
    return null;
  }

  const { alt, src, url } = config[id];

  return (
    <OutboundLink url={`https://${url}`} utm_medium="leaderboard">
      <img alt={alt} className={styles.ad} src={src} />
    </OutboundLink>
  );
};

Ad.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Ad;
